import gameConfig from "../../../../engines/configs/gameConfig";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import ObjectUtil from "../../../../engines/libs/ObjectUtil";
import utilsModel from "../../../../engines/libs/utilsModel";
import { backpackUseRuleI } from "../../config/backpackConst";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import { NormalBackpackI, NormalBackpackType } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import backpackOpenBase from "../backpackOpenBase";
import { OpenOreDataSaveType, openOreEndInterface, openOreStartInterface } from "./openOreConst";
import openOreGameClean from "./openOreGameClean";
import openOreGameObj from "./openOreGameObj";

const {ccclass, property} = cc._decorator;

@ccclass
export default class openOreOpen extends backpackOpenBase {

	@property({ type: sp.Skeleton, displayName:'' })
	nodeToolsSpine: sp.Skeleton = null;

    @property(cc.Node)
    nodeTools: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeBtnList: cc.Node = null;

	@property({ type: cc.Label, displayName:'' })
	labelBuyPrice: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelSellPrice: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	btnSell: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeSellPrice: cc.Node = null;

    @property({type:cc.Node,displayName:"次数不足节点"})
    notCountNode:cc.Node = null;

    @property({type:cc.Node,displayName:"按钮"})
    cutBtn:cc.Node = null;

    @property({type:cc.Node,displayName:"开始切割按钮"})
    startCutBtn:cc.Node = null;

    @property({type:cc.Node,displayName:"刀片节点"})
    daoNode:cc.Node = null;

    @property({type:cc.Prefab,displayName:"蚌壳预制体"})
    objPrefab:cc.Prefab = null;

    @property({type:cc.Label,displayName:"次数文本"})
    lb_count:cc.Label = null;

    @property({type:cc.Node,displayName:"提示文本"})
    hintNode:cc.Node = null;

    @property({type:cc.Animation,displayName:"刀子动画节点"})
    cutAni:cc.Animation = null;

    @property({type:cc.Prefab,displayName:"事件弹窗"})
    eventPrefab:cc.Prefab = null;

    @property({type:cc.Prefab,displayName:"结算界面"})
    cleanPrefab:cc.Node = null;
    
    juzijuSoundId:number = null;

    canCut:boolean = true;

    openOreNode:cc.Node = null;

    completeY:number = 300;

    private openCountKey:string = OpenOreDataSaveType.OPEN_ORE_CUT_KEY; 

    private openCountDayKey:string = OpenOreDataSaveType.OPEN_ORE_CUTCOUNT_DAY_KEY;

    buyScript:openOreGameObj = null;

    cutEndInterface:openOreEndInterface = null;

    cutInitY:number = 0;

    cutTargetX:number = 0;

    cutTargetY:number = 0;

    onBackPackOpenPrefab(useRule:backpackUseRuleI){
        
        // super.onBackPackOpenPrefab(useRule);
        let backpackItem:NormalBackpackI = backPackEventMap()[useRule.backId];
        let openOreManager = NormalGameManager._instance.openOreManager;
        let startData = openOreManager.getOneStartDataByBackpackItem(backpackItem);
        if(startData){
            let node = cc.instantiate(this.objPrefab);
            let ps = node.getComponent(openOreGameObj);
            ps.bindDate(startData,null,false);
            this.bindNode(node);
            this.openOreNode = node;
        }
    }

    onLoad(){
        this.openOreNode.setParent(this.node);
        this.openOreNode.setPosition(cc.v2(0,-100));
        this.daoNode.zIndex = 1;
        this.startCutBtn.zIndex = 1;
        this.cutBtn.zIndex = 1;
        this.btnSell.zIndex = 1;
        this.cutInitY = this.daoNode.y;
        this.buyScript.canClick = false;
        this.nodeToolsSpine.node.active = false;
        this.nodeToolsSpine.node.zIndex = 2;

        this.btnSell.active = false;
        this.nodeSellPrice.active = false;

        this.nodeSellPrice.zIndex = 1;
        this.nodeBtnList.zIndex = 1;

        this.buyScript.updatePrice();
        this.updateCutBtn();
        // this.daoNode.on('touchstart',this.onTouchStartDaoNode,this);
        // this.daoNode.on('touchmove',this.onTouchMoveDaoNode,this);
        // this.daoNode.on('touchend',this.onTouchEndDaoNode,this);
        // this.daoNode.on('touchcancel',this.onTouchEndDaoNode,this);
        // this.cutAni.play("Idle");
    }

    onTouchStartDaoNode(e:cc.Event.EventTouch){
        if(this.getCutCount() >=gameConfig.OPEN_ORE_CUT_COUNT){
            O1HD.getModules().uiControlModule.showMessageBox("开石次数不足,请补充次数");
            return;
        }
        this.hintNode.active = false;
        // this.cutAni.play("Cut");
    }
    
    onTouchMoveDaoNode(e:cc.Event.EventTouch){
        if(!this.canCut){
            return;
        }
        if(this.getCutCount() >=gameConfig.OPEN_ORE_CUT_COUNT){
            return;
        }
        let detal = e.getDelta();
        if(detal.y > 0){
            this.daoNode.y += detal.y;
            if(this.daoNode.y >= this.completeY){
                // 完成
                this.canCut = false;
                this.completeAni();
            }
        }
    }

    onTouchEndDaoNode(e:cc.Event.EventTouch){
        this.hintNode.active = true;
        // this.cutAni.play("Idle");
    }

    bindNode(node:cc.Node){
        this.openOreNode = node;
        // this.cutNode.active = true;
        this.buyScript = this.openOreNode.getComponent(openOreGameObj);

        this.cutTargetX = this.buyScript.startData.onePosX;
        this.completeY = this.buyScript.startData.onePosY;
        this.daoNode.x = this.cutTargetX;

        this.resiveCutCount();
        this.updateCutLabel();
    }

    resiveCutCount(){
        let oldday = O1HD.getServices().localStorageSrv.getStorage(this.openCountDayKey);
        let today = data_control.getCurrDateDayString();
        if(oldday != today){
            this.setOpenCount(0);
            O1HD.getServices().localStorageSrv.setStorage(this.openCountDayKey,today);
        }
    }

    getCutCount(){
        let s = O1HD.getServices().localStorageSrv.getStorage(this.openCountKey) || "0";
        let sCount:number = Number(s);
        if(isNaN(sCount)){
            sCount = 0;
        }
        return sCount;
    }

    setOpenCount(count:number,isPlus:boolean = false){
        let cutCount = this.getCutCount();
        if(isPlus){
            cutCount += count;
        }else{
            cutCount = count;
        }
        O1HD.getServices().localStorageSrv.setStorage(this.openCountKey,cutCount);
    }

    onBtnCut(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.setOpenCount(0);
            this.updateCutLabel();
        },()=>{

        },null,"观看视频获得开石头次数");
    }

    updateCutBtn(){
        this.cutBtn.active = false;
        this.startCutBtn.active = false;
        if(this.getCutCount() >= gameConfig.OPEN_ORE_CUT_COUNT){
            this.cutBtn.active = true;
        }else{
            this.startCutBtn.active = true;
        }
    }

    updateCutLabel(){
        this.lb_count.string = `(${this.getCutCount()}/${gameConfig.OPEN_ORE_CUT_COUNT})`;
        this.updateCutBtn();
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.node.destroy();
        this.node.removeFromParent();
    }

    //切割完成的动画
    async completeAni(){
        this.setOpenCount(1,true);
        let incident:openOreEndInterface = null;
        if(this.cutEndInterface){
            let incidents = this.cutEndInterface.incidents;
            if(incidents.length > 0){
                incident = this.getOneIncident(this.cutEndInterface);
                this.cutEndInterface = incident;
                this.buyScript.openTwo(this.cutEndInterface);
            }
        }else{
            let end = this.buyScript.startData;
            incident = this.getOneIncident(end);
            this.cutEndInterface = incident;
            this.buyScript.openOne(this.cutEndInterface);
            NormalGameManager._instance.backpackManager.outOneGood(this.buyScript.startData.bindBackId);
        }
        this.cutTargetX = this.buyScript.startData.twoPosX;
        this.completeY = this.buyScript.startData.twoPosY;
        this.updateCutLabel();
        // this.hintNode.active = true;
        O1HD.getManagers().soundMgr.stopSound(this.juzijuSoundId);
        // O1HD.getManagers().soundMgr.playSound("songkaijuzi");
        // this.cutAni.play("Idle");
        await this.cutBack();
        this.showEndDialog();
    }

    //点击开石切割石头
    onBtnStartCut(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        if(!this.canCut){
            return;
        }

        if(this.getCutCount() >=gameConfig.OPEN_ORE_CUT_COUNT){
            return;
        }

        this.btnSell.active = false;
        this.canCut = false;
        this.hintNode.active = false;
        // this.cutAni.play("Cut");
        O1HD.getManagers().soundMgr.playSound("juziju").then(id=>{
            this.juzijuSoundId = id;
        });
        // let needTime:number = Math.abs(this.completeY - this.daoNode.y) / 300;
        // cc.tween(this.daoNode).to(needTime,{y:this.completeY}).start();

        this.nodeToolsSpine.node.active = true;
        let trackEntry = this.nodeToolsSpine.setAnimation(0, 'animation', false);

        let eY = this.buyScript.node.y;
        // let eY = this.completeY - this.nodeToolsSpine.node.height/2;
        this.nodeToolsSpine.node.setPosition(this.cutTargetX, eY);

        // let nHeight = this.buyScript.getNodeHeight();
        this.scheduleOnce(this.completeAni, trackEntry.animation.duration);
    }

    cutBack(){
        return new Promise<void>(resolve=>{
            // let needTime:number = cc.v2(this.cutTargetX,this.cutInitY).sub(cc.v2(this.daoNode.x,this.daoNode.y)).mag() / 500;
            // cc.tween(this.daoNode).to(needTime,{x:this.cutTargetX,y:this.cutInitY}).start();
            let needTime = 0.5;
            this.scheduleOnce(resolve,needTime);
        });

        // this.daoNode.y = this.cutInitY;
    }

    showEndDialog(){
        let incident:openOreEndInterface = this.cutEndInterface;
        let incidents = incident.incidents;
        let rate = NormalGameManager._instance.getPriceRate();
        let oPrice = this.cutEndInterface.price;
        this.cutEndInterface.price = Math.floor( rate * oPrice );
        if(incidents.length > 0){

            // // 测试代码
            // console.log(`第一刀 id = ${this.cutEndInterface.id}  倍数： `,rate, ', 原售价：'+ oPrice,  '现售价：'+ this.cutEndInterface.price);

            // let node:cc.Node = cc.instantiate(this.eventPrefab);
            // let ns = node.getComponent(openOreEventPage);
            // ns.bindData(incident,this);
            // node.setParent(O1HD.Canvas());
            this.showSellPrice();
        }else{
            //  // 测试代码
            //  console.log(`第二刀 id = ${this.cutEndInterface.id}  倍数： `,rate, ', 原售价：'+ oPrice,  '现售价：'+ this.cutEndInterface.price);

            let node:cc.Node = cc.instantiate(this.cleanPrefab);
            let ns = node.getComponent(openOreGameClean);
            ns.bindData(this.buyScript.startData,incident,this.openOreNode,this.node);
            node.setParent(O1HD.Canvas());
            this.nodeBtnList.active = false;
        }
        this.refreshSellPrice();
    }

    showSellPrice() {
        this.canCut = true;
        this.btnSell.active = true;
        this.nodeSellPrice.active = true;
    }

    refreshSellPrice() {

        let ePrice = this.cutEndInterface.price;
        let bShowBp = false;
        let backpackId:number = this.buyScript.openObjId;
        if (backpackId) {
            let backConfig = backPackEventMap()[backpackId];
            if (backConfig) {
                bShowBp = backConfig.type && backConfig.type.includes(NormalBackpackType.NVWA_STORE);
                if (bShowBp) {
                    ePrice = backConfig.sellPrice;
                }
            }
        }

        this.labelSellPrice.string = data_control.getNumberFormat(ePrice);
        this.labelBuyPrice.string = data_control.getNumberFormat(this.buyScript.startData.price);
    }

    onClickSell(e: cc.Event.EventTouch) {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let targetNode:cc.Node = e?.target;
        this.doSell(targetNode);
    }

    onClickSellDouble(e: cc.Event.EventTouch) {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        utilsModel.loadAndShowVideoAdTrans(()=>{
            let targetNode:cc.Node = e?.target;
            this.doSell(targetNode, 2);
        },()=>{

        },null,"切矿石第一刀观看视频双倍卖出")
        
    }

    doSell(itemNode: cc.Node, scale: number = 1) {
        let price:number = this.cutEndInterface.price * scale;
        O1HD.getServices().userSrv.setCoins(price, true, itemNode);
        this.node.destroy();
    }

    getOneIncident(end:openOreEndInterface | openOreStartInterface){
        let incident:openOreEndInterface = null;
        let incidents = end.incidents;
        let weightAry:number[] = [];
        for(let i =0;i<incidents.length;i++){
            let incident = incidents[i]; 
            let weight:number = incident.weight;
            weightAry.push(weight);
        }
        if(weightAry.length > 0){
            let incidentIndex:number = data_control.getRandIPosByWeights(weightAry);
            let incidentId = incidents[incidentIndex].endId;
            incident = NormalGameManager._instance.openOreManager.openOreEndMap[incidentId];

            let cloneObj: openOreEndInterface = ObjectUtil.deepCopy(incident);
            return cloneObj;
        }else{
            return null;
        }
    }
    
}
